<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="autoPriceListDto.id && autoPriceListDto.id > 0">
                                    {{$t('auto.newAutoPriceList.newAutoPrice')}}
                                    {{$t('auto.newAutoPriceList.edit')}}</h4>
                                <h4 class="card-title float-left" v-else>
                                    {{$t('auto.newAutoPriceList.newAutoPrice')}}
                                    {{$t('auto.newAutoPriceList.add')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">

                                <div class="form-group">
                                    <label>{{$t("auto.autoManufacture.manufacture")}} <span class="red">*</span></label>
                                    <v-select v-model="autoPriceListDto.autoManufactureDto" label="name"
                                              :options="autoManufactureList"
                                              :filterable="false"
                                              @search="onAutoManufactureSearch"
                                              @search:focus="onAutoManufactureFocus"
                                              :class="{invalid : $v.autoPriceListDto.autoManufactureDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoPriceListDto && autoPriceListDto.autoManufactureDto && autoPriceListDto.autoManufactureDto.name">
                                            <div v-html="autoPriceListDto.autoManufactureDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoPriceListDto.autoManufactureDto.$error">
                                        {{$t("auto.autoManufacture.error")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.carCategory.category")}} <span class="red">*</span></label>
                                    <v-select v-model="autoPriceListDto.carCategoryDto" label="name"
                                              :options="carCategoryList"
                                              :filterable="false"
                                              @search="onCarCategorySearch"
                                              @search:focus="onCarCategoryFocus"
                                              :class="{invalid : $v.autoPriceListDto.carCategoryDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoPriceListDto && autoPriceListDto.carCategoryDto && autoPriceListDto.carCategoryDto.name">
                                            <div v-html="autoPriceListDto.carCategoryDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoPriceListDto.carCategoryDto.$error">
                                        {{$t("auto.carCategory.error")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <AssetDropZone code="decisionDropZone" label="auto.newAutoPriceList.priceListFile"
                                                   folder="AutoPriceList" :folderName="'Settings'"
                                                   :data="autoPriceListDto.priceListFiles"
                                                   @change="(files) => {autoPriceListDto.priceListFiles = files}"
                                                   :has-error="$v.autoPriceListDto.priceListFiles.$error"/>

                                </div>

                                <div class="form-group">
                                    <label>{{$t("realEstate.field.mibLetterDate")}} <span
                                            class="red">*</span></label>
                                    <datepicker class="form-control" format="dd/MM/yyyy"
                                                v-model="autoPriceListDto.pricingDate"
                                                :clear-button="true"
                                                :class="{invalid : $v.autoPriceListDto.pricingDate.$error}"></datepicker>
                                    <div class="red" v-if="$v.autoPriceListDto.pricingDate.$error">
                                        {{$t("realEstate.validation.mibLetterDate")}}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" v-if="save">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, requiredUnless, minLength} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import Datepicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "AutoPriceListAddEdit",
        components: {
            AssetDropZone,
            Datepicker
        },
        data() {
            return {
                processing: false,
                filter: initFilterModel(),
                autoPriceListDto: {
                    priceListFiles: []
                },
                results: null,
                carCategoryList: [],
                autoManufactureList: []
            }
        },
        validations() {
            return {
                autoPriceListDto: {
                    carCategoryDto: {
                        required: required
                    },
                    autoManufactureDto: {
                        required: required
                    },
                    pricingDate: {
                        required: required
                    },
                    priceListFiles: {
                        required: requiredUnless(() => {
                            return true;
                        }),
                        minLength: minLength(1)
                    }
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                if (id && id > 0) {
                    this.$http.get('/auto-price-list/' + id)
                        .then(res => {
                            vm.autoPriceListDto = res.data;
                            this.autoPriceListDto.pricingDate = parseDate(this.autoPriceListDto.pricingDate);
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (this.autoPriceListDto.pricingDate) {
                    this.autoPriceListDto.pricingDate = formatDate(this.autoPriceListDto.pricingDate);
                }
                this.processing = true;
                this.$http.post('/auto-price-list/save', this.autoPriceListDto)
                    .then(res => {
                            if (res && res.data) {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.common.saved'),
                                    type: 'success'
                                });
                                this.$router.push('/config/auto');
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.processing = false;
                        }
                    ).catch(error => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.common.errorOccurred') + '\n' + error.response.data.message,
                        type: 'error'
                    });
                    this.processing = false;
                });

            },
            cancel() {
                this.$router.push('/config/auto');
            },

            onCarCategorySearch(searchTxt) {
                this.carCategoryList = [];
                this.filter.search = searchTxt;
                this.filter.page.size = 100;
                this.$http.post('car-category/search', this.filter)
                    .then(res => {
                        this.carCategoryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCarCategoryFocus() {
                this.carCategoryList = [];
                this.filter.search = '';
                this.$http.post('car-category/search', this.filter)
                    .then(res => {
                        this.carCategoryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onAutoManufactureSearch(searchTxt) {
                this.autoManufactureList = [];
                this.filter.search = searchTxt;
                this.$http.post('auto-manufacture/search-manufacture-dto', this.filter)
                    .then(res => {
                        this.autoManufactureList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onAutoManufactureFocus() {
                this.autoManufactureList = [];
                this.filter.search = '';
                this.$http.post('auto-manufacture/search-manufacture-dto', this.filter)
                    .then(res => {
                        this.autoManufactureList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },

        },
        computed: {},
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    .custom td, .custom th {
        border: 1px solid #ddd;
        padding: 4px;
    }

    .custom tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    .custom tr:hover {
        opacity: 1;
        background-color: #dee2e6;
    }

    .custom thead tr th {
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }

    .custom tr {
        font-size: 14px;
    }

</style>